export interface NavChild {
  label: string
  to: string
  children?: NavChild[]
}

export interface NavItem {
  label: string
  to?: string
  children?: NavChild[]
}

export const SITE_URL = 'https://fastaid.com.bd'

export const site = {
  name: 'Fast Aid Hospital',
  tagline: 'Medical Care & Diagnostic Center',
  phone: '09610009620',
  phoneHref: 'tel:09610009620',
  phoneAlt: '',
  email: 'info@fastaid.com.bd',
  address: 'Chauddagram, Chittagong, Bangladesh',
  addressShort: 'Chauddagram, Chittagong',
  hours: '24/7 Emergency • Outdoor: 8:00 AM – 8:00 PM',
  mapEmbedUrl:
    'https://maps.google.com/maps?q=Fast%20Aid%20Hospital%20Chauddagram%20Chittagong&t=&z=14&ie=UTF8&iwloc=&output=embed',
  mapLinkUrl: 'https://www.google.com/maps/search/?api=1&query=Fast+Aid+Hospital+Chauddagram',
  coupon: '',
  copyright: '© Copyright 2026 Fast Aid Hospital. All Rights Reserved',
}

export const socials = [
  { label: 'Instagram', icon: 'fa-brands fa-instagram', href: '#' },
  { label: 'Facebook', icon: 'fa-brands fa-facebook-f', href: '#' },
  { label: 'Twitter', icon: 'fa-brands fa-x-twitter', href: '#' },
  { label: 'Pinterest', icon: 'fa-brands fa-pinterest-p', href: '#' },
]

/**
 * Primary navigation. `Home`, `Services` and `Blog` are intentionally plain
 * links — each service and blog post gets its own detail page instead of a
 * submenu.
 */
export const navigation: NavItem[] = [
  { label: 'Home', to: '/' },
  {
    label: 'About Us',
    to: '/about',
    children: [
      { label: 'About Us', to: '/about' },
      { label: 'Doctors', to: '/doctors' },
      { label: 'Gallery', to: '/image-gallery' },
    ],
  },
  { label: 'Services', to: '/services' },
  { label: 'Blog', to: '/blog' },
  { label: 'Contact Us', to: '/contact' },
]
